import React from 'react';
import { Linkedin, Mail, Globe, Heart, Facebook, Instagram, Twitter, Youtube, Music, MessageSquare } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-black border-t border-[#D4AF37]/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <button
              onClick={scrollToTop}
              className="text-3xl font-bold text-white hover:text-[#D4AF37] transition-colors mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Charles Crawshaw
            </button>
            <p
              className="text-white/60 text-sm leading-relaxed"
              style={{ fontFamily: 'Lato, sans-serif' }}
            >
              Transformational Leader • AI Innovator • Global Educator
            </p>
            <p
              className="text-[#D4AF37] text-sm mt-2 font-semibold"
              style={{ fontFamily: 'Lato, sans-serif' }}
            >
              Causing World Peace in our lifetime
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3
              className="text-white font-bold mb-4 text-lg"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Quick Links
            </h3>
            <ul className="space-y-2">
              {['About', 'Skills', 'Experience', 'Projects', 'Movement', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => {
                      const element = document.getElementById(item.toLowerCase());
                      if (element) {
                        const offset = 80;
                        const elementPosition = element.offsetTop - offset;
                        window.scrollTo({
                          top: elementPosition,
                          behavior: 'smooth'
                        });
                      }
                    }}
                    className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm"
                    style={{ fontFamily: 'Lato, sans-serif' }}
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect Section */}
          <div>
            <h3
              className="text-white font-bold mb-4 text-lg"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Connect
            </h3>
            <div className="grid grid-cols-5 gap-3 mb-4">
              <a
                href="https://www.facebook.com/charlesn888"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/charlesn888/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://x.com/charlesngo888"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="Twitter/X"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://www.linkedin.com/in/charles-ngo-world-peace-now/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://www.youtube.com/@worldpeacenow888"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="YouTube"
              >
                <Youtube size={18} />
              </a>
              <a
                href="https://www.tiktok.com/@charlesn888"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="TikTok"
              >
                <Music size={18} />
              </a>
              <a
                href="https://www.pinterest.com/charlesn888/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="Pinterest"
              >
                <Globe size={18} />
              </a>
              <a
                href="https://www.threads.net/@charlesn888"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="Threads"
              >
                <MessageSquare size={18} />
              </a>
              <a
                href="https://bsky.app/profile/charlesn888.bsky.social"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="Bluesky"
              >
                <Globe size={18} />
              </a>
              <a
                href="mailto:wp2020@gmail.com"
                className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                aria-label="Email"
              >
                <Mail size={18} />
              </a>
            </div>
            <p
              className="text-white/60 text-sm leading-relaxed"
              style={{ fontFamily: 'Lato, sans-serif' }}
            >
              Open to collaborations that make a difference in AI, education, media, and global impact.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#D4AF37]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p
              className="text-white/60 text-sm"
              style={{ fontFamily: 'Lato, sans-serif' }}
            >
              © {currentYear} Charles Crawshaw. All rights reserved.
            </p>
            <p
              className="text-white/60 text-sm flex items-center gap-2"
              style={{ fontFamily: 'Lato, sans-serif' }}
            >
              Built with <Heart className="w-4 h-4 text-[#D4AF37]" fill="currentColor" /> for a better world
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
